import React from "react";
import "./FinanceServices.scss";

const services = [
  { icon: "../assets/img/finance/finance-services-img1.png", label: "Business Strategy" },
  { icon: "../assets/img/finance/finance-services-img2.png", label: "Financial Consulting" },
  { icon: "../assets/img/finance/finance-services-img3.png", label: "Marketing & Branding" },
  { icon: "../assets/img/finance/finance-services-img4.png", label: "Sales Consulting" },
  { icon: "../assets/img/finance/finance-services-img5.png", label: "Human Resources" },
];

const FinanceServices = () => {
  return (
    <div className="finance-container">
      <div className="finance-sidebar">
        {services.map((service, idx) => (
          <div className="finance-service-item" key={idx}>
            <img
              src={service.icon}
              alt={service.label}
              className="finance-icon"
            />
            <span className="finance-label">{service.label}</span>
          </div>
        ))}
      </div>

      <div className="finance-content">
        <div className="finance-headerServices">SERVICES</div>
        <h2 className="finance-title">
          We Helping You Unlock The<br></br> Opportunities, Success.
        </h2>
        <p className="finance-subtext">
          Exploring alternatives such as social media advertising, influencer
          partnerships, email marketing & SEO optimization can help diversify
          your reach.
        </p>

        <div className="finance-video-section">
          <div className="finance-video">
             
            <img
              src="../assets/img/finance/service-three-image.jpg"
              alt="Video Thumbnail"
              className="finance-thumbnail"
            />
            
            <span class="material-symbols-outlined ">play_circle</span>
             
            
          </div>

          <div className="finance-features">
            <h3 className="finance-feature-heading">
              With an innovative approach to<br></br> problem-solving, we recognize<br></br>
              solutions as a driving force
            </h3>
            <ul className="finance-feature-list">
              <li><span class="material-symbols-outlined">check</span><span>Enhance Operational Efficiency</span> </li>
              <li><span class="material-symbols-outlined">check</span><span> Designing Tailored Solutions</span></li>
              <li><span class="material-symbols-outlined">check</span><span> Dedicated Team Member</span></li>
              <li><span class="material-symbols-outlined">check</span><span> Delivering Exceptional Value</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinanceServices;
